"use strict";

emailBlast.classy.controller({
    name: "EmailArchiveModalController",
    inject: ["$scope", "$modal", "$modalInstance", "$http",
        "EmailBlastArchiveModelService", "EmailBlastRecipientsModelService", "EmailBlastService", "authServiceFactory"],
    init: function () {
        var parent = this;
        this.$.$modalInstance = this.$modalInstance;
        this.$.EmailBlastService = this.EmailBlastService;
        this.$.archiveData = null;
        this.$.recipients = null;
        this.$.archiveStats = null;
        this.$.loading = true;

        //get list of people who opened it
        this.EmailBlastArchiveModelService.resolveData(this.authServiceFactory.getAuth().schoolID)
        	.then(function(data) {
                parent.$.archiveData = data[0].data;
                parent.$.loading = false;
        	});
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY h:mm a');
    },
    viewRecipients: function(emailscope) {
        this.$.loading = true;
        var parent = this;
        this.$http.get("/api/EmailBlastArchiveSent/"+emailscope.recordID+"/Recipients")
            .then(function(result) {
                parent.$.recipients = {};
                result.data.forEach(function(r) {
                    if (!parent.$.recipients[r.email]) {
                        parent.$.recipients[r.email] = [];
                    }
                    parent.$.recipients[r.email].push(r.Fam_Name_First +" "+ r.Fam_Name_Last);
                });
                parent.$.loading = false;
            });
        this.loadStats(emailscope);
    },
    loadStats: function(emailscope) {
        this.$.archiveStats = {};
        this.$.archiveStats.stats = "loading";
        let schoolID = this.authServiceFactory.getAuth().schoolID;

        this.$http.get("/api/EmailBlastArchive/" + schoolID + "/Stat/"+emailscope.mcCampaignID)
            .then((result) => {
                this.$.archiveStats.stats = result.data;
                // retrieve detailed open stats
            }, () => {
                this.$.archiveStats.stats = "error";
            });
        this.$http.get("/api/EmailBlastArchive/" + schoolID + "/Opened/" + emailscope.mcCampaignID)
            .then((result) => {
                this.$.archiveStats.opened = result.data.members;
                this.$.archiveStats.notOpened = angular.copy(this.$.recipients);
                this.$.archiveStats.opened.forEach((v) => {
                    delete this.$.archiveStats.notOpened[v.email_address];
                });
            });
    },
    setEmail: function(email) {
        this.EmailBlastService.email.message = email.message;
        this.EmailBlastService.email.from = email.from;
        this.EmailBlastService.email.fromAddress = email.fromAddress;
        this.EmailBlastService.email.subjectLine = email.subjectLine;
        this.EmailBlastService.email.sentGroup = [];
        this.EmailBlastService.email.sentSubGroup = "ALL";
        this.EmailBlastService.email.LYA = 0;
        this.$modalInstance.dismiss('cancel')
    },
    back: function() {
        if (this.$.showStats)
            this.$.showStats = null;
        else {
            this.$.recipients = null;
            this.$.archiveStats = null;
        }
    }

});

emailBlast.filter("reverse", function() {
    return function (items) {
        if (items)
            return items.slice().reverse();
        else return items;
    };
});